export const initialAccessListState = {
  owner: null,
  users: [],
  userGroups: [],
  organization: null,
  isLoading: false,
  isFetched: false,
  isError: false,
}

export const emptyPendingPermissions = {
  users: {},
  userGroups: {},
  organization: undefined,
}

export const emptyPendingRecipients = []
